
import Cookies from "universal-cookie";
import {CreateWidgetIcon}  from './CreateWidgetIcon';
import {CreatedWidgetsIcon} from './CreatedWidgetsIcon';
import {CreateSenderIcon} from './CreateSenderIcon';
import {CreatedSendersIcon} from './CreatedSendersIcon';
import {BalanceIcon} from './BalanceIcon';
import {ExitIcon} from './ExitIcon';
import {SupportIcon} from './SupportIcon';
import RightArrowIcon from './RightArrowIcon';
import { useState, useEffect } from 'react';
import Logo from './img/bubble.png';

function Menu(props) {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Определяем мобильное устройство
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Закрываем меню при клике на ссылку (на мобильных)
  const handleLinkClick = () => {
    if (isMobile) {
      setMenuOpen(false);
    }
  };

  return (
    <>
      {/* Кнопка для открытия меню на мобильных */}
      {isMobile && (
        <div 
          className="mobile-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            position: 'fixed',
            top: '1em',
            left: '1em',
            zIndex: 1001,
            background: '#0767F4',
            color: 'white',
            width: '3em',
            height: '3em',
            borderRadius: '0.5em',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
          }}
        >
          {menuOpen ? '✕' : '☰'}
        </div>
      )}

      <div className={`fullPage_leftMenu ${isMobile ? (menuOpen ? 'mobile-menu-open' : 'mobile-menu-closed') : ''}`}>
        <div className='fullPage_leftMenu_menu'>
        <div className='fullPage_leftMenu_logo'>
          <img src={Logo} alt="Logo" /> 
          <span className='fullPage_leftMenu_logo_text'> Clickanti </span> 
        </div>
          <ul>
            <a href='/createwebsite' onClick={handleLinkClick}>
              <li className={props.page == 'createwebsite' ? "selectedMenuItem icon1 icon" : "icon1 icon"}>  
                <CreateWidgetIcon/> 
                <span className="menuItemText firstMenuItemText">
                  Добавить сайт на защиту
                </span>
                <RightArrowIcon />
              </li>
            </a>

            <a href='/websites' onClick={handleLinkClick}>
              <li className={props.page == 'websites' ? "selectedMenuItem icon2 icon" : "icon2 icon"}>
                <CreatedWidgetsIcon />
                <span className="menuItemText secondMenuItemText">
                  Мои сайты
                </span>
                <RightArrowIcon />
              </li>
            </a>

            <a href='/affiliate' onClick={handleLinkClick}>
              <li className={props.page == 'affiliate' ? "selectedMenuItem icon4 icon" : "icon4 icon"}>   
                <CreatedSendersIcon />
                <span className="menuItemText fourthMenuItemText">
                  Партнерская программа
                </span>
                <RightArrowIcon />
              </li>
            </a>
           
            <a href='/balance' onClick={handleLinkClick}>
              <li className={props.page == 'balance' ? "selectedMenuItem icon5 icon" : "icon5 icon"}>  
                <BalanceIcon />
                <span className="menuItemText fifthMenuItemText">
                  Оплата
                </span>
                <RightArrowIcon />
              </li>
            </a>
          </ul>

          <div className='border-bottom'>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="117"
              height="1"
              fill="none"
              viewBox="0 0 117 1"
            >
              <path stroke="url(#paint0_linear_35_988)" d="M0 0.5L117 0.5"></path>
              <defs>
                <linearGradient
                  id="paint0_linear_35_988"
                  x1="-0.325"
                  x2="117.101"
                  y1="1"
                  y2="1"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#0767F4"></stop>
                  <stop offset="1" stopColor="#2AC3D1"></stop>
                </linearGradient>
              </defs>
            </svg>
          </div>

          <ul>
            <a href='https://t.me/arturcronberg' target="_blank" rel="noopener noreferrer" onClick={handleLinkClick} className="icon6 icon">
              <li>
                <SupportIcon />
                <span className="menuItemText sixthMenuItemText">
                  Тех. поддержка
                </span> 
                <RightArrowIcon />
              </li>
            </a>
            <li 
              onClick={() => {
                const cookies = new Cookies();
                cookies.remove('clickanti_token', {path: '/'});
                window.location.href = '/auth';
                handleLinkClick();
              }} 
              className='icon7 icon'
              style={{cursor: 'pointer'}}
            >
              <ExitIcon/>
              <span className="menuItemText seventhMenuItemText">
                Выход
              </span>    
            </li> 
          </ul>
        </div>
      </div>

      {/* Затемнение фона при открытом меню на мобильных */}
      {isMobile && menuOpen && (
        <div 
          className="menu-overlay"
          onClick={() => setMenuOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 999
          }}
        />
      )}
    </>
  );
}

export default Menu;
